export class TransactionTableRQ {
    constructor(pageNum, pageSize, productCode) {
        this.pageNum = pageNum;
        this.pageSize = pageSize;
        this.productCode = productCode;
    }
}